import * as React from "react";
import { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";

type MultiselectDropdownProps = React.PropsWithChildren<{
    id?: string;
    label?: string;
    cssWrapper?: string;
    placeholder?: string;
    disabled?: boolean;
    scroll?: {
        maxHeight: number;
    };
}>;

export const MultiselectDropdown = (props: MultiselectDropdownProps) => {
    const wrapperRef = useRef(null);
    const { label, placeholder, disabled } = props;
    const [isOpen, setIsOpen] = useState(false);

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {setIsOpen(false);}
    };

    const ToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const CSSClasses = classNames("form-group multiselect-dropdown", props.cssWrapper);
    const containerStyle: React.CSSProperties = {};
    if (props.scroll) {
        containerStyle.overflowY = "auto";
        containerStyle.maxHeight = props.scroll.maxHeight + "px";
    }

    return (
        <div className={CSSClasses} ref={wrapperRef}>
            <label className="control-label" id={props.id}>
                {label}
            </label>
            <div className="controls-wrap">
                <button
                    className="trigger"
                    onClick={() => ToggleDropdown()}
                    aria-expanded={isOpen}
                    aria-labeledby={props.id}
                    disabled={disabled || false}
                    style={disabled ? { backgroundColor: "#f4f4f4" } : null}
                >
                    <span className="text">{placeholder}</span>
                    <span className="icon" aria-hidden={true} />
                </button>
                <CSSTransition in={isOpen} timeout={300} unmountOnExit classNames="a-dropdown">
                    <div className="dropdown-list" aria-hidden={!isOpen} style={containerStyle}>
                        <div className="dropdown-list-panel">{props.children}</div>
                        <button className="btn primary ml-20" onClick={() => ToggleDropdown()}>
                            Save
                        </button>
                    </div>
                </CSSTransition>
            </div>
        </div>
    );
};
